import React from 'react'
import { Link } from 'react-router-dom'
import config from '../../config/config'
import * as routes from '../../config/routes'
import { getPoiLabel } from '../../utils/utils'
import { useLanguage } from '../../contexts/LanguageContext'
import { useTranslation } from 'react-i18next'

const PoiTypeThumbnail = ({ poiType }) => {
  const { t } = useTranslation()
  const { activeLanguage } = useLanguage()

  const poiTypeLabel = getPoiLabel(poiType, activeLanguage)
  const imgSrc = `${config.thumbnailsPath}POI_TYPE_${poiType.name}.jpg`
  const poiTypeLinkPath = routes[`${poiType.name}_PATH`]

  return (
    <Link to={poiTypeLinkPath} className="card-hover">
      <img src={imgSrc} alt={poiTypeLabel} />
      <div className="card-body">
        <h3>{t(`POI_TYPE_${poiType.name}_PAGE_TITLE`)}</h3>
        <p>{t(`POI_TYPE_${poiType.name}_PAGE_DESCRIPTION`)}</p>
      </div>
    </Link>
  )
}

export default PoiTypeThumbnail
